import { useEffect, useState } from "react";
import { Button, Empty, Input, Pagination, Tabs } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { fetchSaleActivityList } from "./api";
import ActivityCard from "./components/ActivityCard";
import { SaleActivityInfo } from "./types";
import "./activity.scss";

const tabList = [
  { key: "", label: "全部" },
  { key: "1", label: "待开始" },
  { key: "2", label: "活动中" },
  { key: "3", label: "已结束" },
];

export default function SaleActivityList() {
  const [list, setList] = useState<SaleActivityInfo[]>([]);
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [total, setTotal] = useState(0);

  const loadList = (page = currentPage) => {
    const activityInfo: any = {};
    if (name) activityInfo.name = name;
    if (status) activityInfo.activityLearnStatus = Number(status);
    fetchSaleActivityList({
      activityInfo,
      page: { currentPage: page, pageSize },
    }).then((res) => {
      const data = res.data || {};
      setList(data.activityList || []);
      setTotal(data.page?.totalResultSize || 0);
      setCurrentPage(data.page?.currentPage || page);
    });
  };

  useEffect(() => {
    loadList(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <div className="sale-activity-page">
      <div className="sale-activity-page__head">
        <h3>学术活动</h3>
      </div>
      <div className="sale-activity-filter">
        <Tabs activeKey={status} onChange={(key) => setStatus(key)}>
          {tabList.map((item) => (
            <Tabs.TabPane key={item.key} tab={item.label} />
          ))}
        </Tabs>
        <div className="sale-activity-search">
          <Input.Search
            className="sale-activity-search__input"
            value={name}
            placeholder="请输入活动名称"
            enterButton={<><SearchOutlined /> 搜索</>}
            onChange={(e) => setName(e.target.value)}
            onSearch={() => loadList(1)}
          />
          <Button className="sale-activity-search__reset" onClick={() => {
            setName("");
            setStatus("");
            setCurrentPage(1);
            setTimeout(() => loadList(1));
          }}>
            重置
          </Button>
        </div>
      </div>
      <div className="sale-activity-list-body">
        {list.length > 0 ? (
          <>
            <div className="sale-activity-grid sale-activity-grid--list">
              {list.map((item) => (
                <ActivityCard key={item.activityId} activity={item} compact />
              ))}
            </div>
            <div className="sale-activity-pagination">
              <Pagination
                total={total}
                current={currentPage}
                pageSize={pageSize}
                showSizeChanger
                onChange={(page, size) => {
                  setPageSize(size || pageSize);
                  setCurrentPage(page);
                  setTimeout(() => loadList(page));
                }}
              />
            </div>
          </>
        ) : (
          <div className="sale-activity-empty">
            <Empty description="暂无学术活动" />
          </div>
        )}
      </div>
    </div>
  );
}
